module.exports = require("/vercel/path0/src/emotion-cache-props")